module.exports = __webpack_public_path__ + "assets/img/star.3bc5f779.png";